<form>
  <pp-otp-form
    [title]="'signup.emailOtp.confirm.title'"
    [control]="form.get('code_email')"
    [sentTo]="user().email"
    [numberSize]="numberSize"
    [hasAutofocus]="false"
    (resend)="resendEmailCode.emit()" />

  <hr />

  <pp-otp-form
    [title]="'signup.phone.confirm.title'"
    [control]="form.get('code_phone')"
    [sentTo]="'+' + user().phone"
    [numberSize]="numberSize"
    [hasAutofocus]="false"
    (resend)="resendPhoneCode.emit()" />

  <div class="pp-form-actions">
    <button
      type="button"
      puButton
      size="m"
      uiType="secondary"
      (click)="back.emit()">
      {{ 'editUser.verify.btn.back' | translate }}
    </button>
    <button
      type="button"
      puButton
      size="m"
      uiType="primary"
      [disabled]="form.invalid"
      (click)="submit.emit(form.value)">
      {{ 'editUser.verify.btn.confirm' | translate }}
    </button>
  </div>
</form>
